import { FC, ReactNode, useCallback, useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import copy from "copy-to-clipboard";
import {
  IconButton,
  IconButtonTypeMap,
  Theme,
  Tooltip,
  TooltipProps,
} from "@mui/material";
import { SxProps } from "@mui/system";
import { useTimeoutWhen } from "rooks";

interface CopyIconButtonProps {
  data: string;
  visible?: boolean;
  color?: IconButtonTypeMap["props"]["color"];
  sx?: SxProps<Theme>;
  children?: ReactNode;
  TooltipProps?: Omit<TooltipProps, "children" | "title">;
}

export const CopyIconButton: FC<CopyIconButtonProps> = ({
  data,
  visible = true,
  color,
  sx,
  children,
  TooltipProps,
}) => {
  const [copied, setCopied] = useState(false);

  useTimeoutWhen(
    () => {
      setCopied(false);
    },
    3000,
    copied,
  );

  const handleCopyClick = useCallback(
    (e: any) => {
      setCopied(true);
      copy(data);
      e.preventDefault();
    },
    [data],
  );

  return (
    <Tooltip arrow title={copied ? "Copied!" : "Copy"} {...TooltipProps}>
      <IconButton
        onClick={handleCopyClick}
        size="small"
        color={color}
        sx={{ visibility: !visible ? "hidden" : "initial", ml: 1, ...sx }}
      >
        {children ?? <ContentCopyIcon fontSize="inherit" />}
      </IconButton>
    </Tooltip>
  );
};
